import styled from 'styled-components';
import { ThemeColours } from '../../../../styles/ThemeColours';
import {
  FontSize,
  FontWeight,
  FONT_STACK,
  LineHeight,
  PRESSABLE,
} from '../../../../styles/constants';
import { Button } from '../../../Button/Button';
import { Link } from '../../../Link';
import { IconCross } from '../../../icons/IconCross';

export const JumbotronView = styled.div<{ loggedIn: boolean }>`
  ${FONT_STACK};
  background-color: ${ThemeColours.primary100};
  color: ${ThemeColours.mono900};

  padding: 24px 24px 53px 24px;
`;

export const ActionBar = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
`;

export const Close = styled(IconCross).attrs({ 'data-testid': 'CloseIcon' })`
  ${PRESSABLE};
  color: inherit;
  fill: currentColor;
  height: 32px;
  width: 32px;
`;

export const Greeting = styled.div`
  color: inherit;
  font-size: ${FontSize.HEADING_3};
  font-weight: ${FontWeight.BOLD};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledLink = styled(Link)`
  ${PRESSABLE};
  align-items: center;
  color: inherit;
  display: flex;
  flex-direction: row;
  font-size: ${FontSize.LARGE};
  font-weight: ${FontWeight.REGULAR};
  line-height: ${LineHeight.LARGE};
  margin: 26px 0 0px;
  text-decoration: none;
  width: fit-content;
`;

export const Icon = styled.svg`
  color: inherit;
  fill: currentColor;
  flex-shrink: 0;
  height: 20px;
  margin-inline-end: 8px;
  width: 20px;
`;

export const Welcome = styled.div`
  color: inherit;
  font-size: ${FontSize.HEADING_5};
  font-weight: ${FontWeight.SEMI_BOLD};
`;

export const Login = styled(Button)`
  ${PRESSABLE};
  align-items: center;
  background-color: ${ThemeColours.primary700};
  border: solid 1px ${ThemeColours.white};
  border-radius: 16px;
  box-sizing: border-box;
  color: ${ThemeColours.white};
  display: inline-flex;
  font-size: ${FontSize.SMALL};
  font-weight: ${FontWeight.SEMI_BOLD};
  height: 32px;
  justify-content: center;
  margin-top: 24px;
  padding: 0 16px;
  text-decoration: none;
  width: unset;

  &:hover {
    background-color: ${ThemeColours.white};
    color: ${ThemeColours.primary700};
  }
`;
